import gql from 'graphql-tag'

export const updateLink = ({ linkId, linkData, linkRoles }) => {
	return {
		mutation: gql`
			mutation updateSingleLink(
				$link_id: bigint!
				$name: String!
				$country_id: bigint!
				$url: String!
				$order: smallint!
				$publishing_date: timestamptz!
				$link_roles: [links_roles_insert_input!]!
			) {
				update_links_by_pk(
					pk_columns: { id: $link_id }
					_set: {
						link_name: $name
						link_url: $url
						country_id: $country_id
						order: $order
						publishing_date: $publishing_date
					}
				) {
					link_name
				}
				delete_links_roles(where: { link_id: { _eq: $link_id } }) {
					affected_rows
				}
				insert_links_roles(objects: $link_roles) {
					affected_rows
				}
			}
		`,
		variables: {
			...linkData,
			link_id: linkId,
			link_roles: linkRoles.map(rol => ({
				link_id: linkId,
				rol_id: rol.id
			}))
		}
	}
}
